import Cookie from 'js-cookie';
import { COOKIE_CONSENT_KEY, COOKIE_EXPIRES } from '../../config/cookiesConfig';
import { storableError } from 'util/errors';
import updateCookieToUserMetadata from '../../api';

// ================ Action types ================ //
const SAVE_COOKIE_CONSENT = 'app/CookieConsent/SAVE_COOKIE_CONSENT';

const SET_COOKIE_CONSENT_REQUEST = 'app/CookieConsent/SET_COOKIE_CONSENT_REQUEST';
const SET_COOKIE_CONSENT_SUCCESS = 'app/CookieConsent/SET_COOKIE_CONSENT_SUCCESS';
const SET_COOKIE_CONSENT_ERROR = 'app/CookieConsent/SET_COOKIE_CONSENT_ERROR';

// ================ Reducer ================ //
const initialState = {
  cookieConsent: '',

  isSettingConsent: false,
  setConsentError: null,
};

const cookieConsentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SAVE_COOKIE_CONSENT:
      return {
        ...state,
        cookieConsent: payload,
      };

    case SET_COOKIE_CONSENT_REQUEST:
      return {
        ...state,
        isSettingConsent: true,
        setConsentError: null,
      };

    case SET_COOKIE_CONSENT_SUCCESS:
      return {
        ...state,
        cookieConsent: payload,
        isSettingConsent: false,
        setConsentError: null,
      };

    case SET_COOKIE_CONSENT_ERROR:
      return {
        ...state,
        isSettingConsent: false,
        setConsentError: payload,
      };

    default:
      return state;
  }
};

// ================ Action creators ================ //
export const saveCookieConsent = (cookieConsent) => ({
  type: SAVE_COOKIE_CONSENT,
  payload: cookieConsent,
});

export const setCookieConsentRequest = () => ({
  type: SET_COOKIE_CONSENT_REQUEST,
});

export const setCookieConsentSuccess = (cookieConsent) => ({
  type: SET_COOKIE_CONSENT_SUCCESS,
  payload: cookieConsent,
});

export const setCookieConsentError = (error) => ({
  type: SET_COOKIE_CONSENT_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //
export const setConsent = (cookieConsent) => async (dispatch, getState) => {
  dispatch(setCookieConsentRequest());

  try {
    const state = getState();
    const currentUser = state.user?.currentUser;
    const userId = currentUser?.id;

    if (userId) {
      await updateCookieToUserMetadata({ userId, cookieConsent });
    } else {
      Cookie.set(COOKIE_CONSENT_KEY, cookieConsent, {
        expires: COOKIE_EXPIRES,
        path: '/',
      });
    }

    dispatch(setCookieConsentSuccess(cookieConsent));
  } catch (error) {
    dispatch(setCookieConsentError(storableError(error)));
  }
};

export default cookieConsentReducer;
